import * as React from "react";
import { useIntl } from "react-intl";
import { Grid, Header } from "semantic-ui-react";

import * as DTO from "../../../../../interfaces";
import { PromptServices } from "../../../../../services";
import { SearchComponent } from "../../../../../components";

import PromptSearchList from "./components/PromptSearchList";
import PromptList from "./components/PromptList";

import { CampaignPromptsType, descriptors } from "./descriptors";

import { BlueTag } from "../../../../../styling/baseStyle";
import "./styles.scss";
import { useCategories } from "../../../../../utils";

interface OwnProps {
  coachId: string;
  campaignPrompts?: DTO.SelectedPrompts;
  onChangeHandler: (selectedPrompts: DTO.SelectedPrompts) => void;
}

type Props = OwnProps;

const CampaignPromptFC: React.FC<Props> = ({ coachId, campaignPrompts = {}, onChangeHandler }) => {
  const { formatMessage } = useIntl();
  const [searchActive, setSearchActive] = React.useState<boolean>(false);

  const [searchedPromptList, setSearchedPromptList] = React.useState<DTO.Prompt[]>([]);
  const { categories, categoryOptions } = useCategories("LIBRARY");

  const [selectedPrompts, setSelectedPrompts] = React.useState<DTO.SelectedPrompts>(campaignPrompts);

  React.useEffect(() => {
    onChangeHandler(selectedPrompts);
  }, [selectedPrompts]);

  const addPromptHandler = (prompt: DTO.Prompt) => {
    const { promptId, categories: categoriesPrompt, title, post } = prompt;
    const currentPrompts: DTO.SelectedPrompts = {
      ...selectedPrompts,
      [promptId!]: {
        categoryIds: categoriesPrompt ? categoriesPrompt!.map(cat => cat.categoryId!) : [],
        title,
        prompt,
        post,
      },
    };

    setSelectedPrompts(currentPrompts);
  };

  const removePromptHandler = (prompt: DTO.Prompt) => {
    const { promptId } = prompt;
    setSelectedPrompts(finalPrompts => {
      delete finalPrompts[promptId!];
      return { ...finalPrompts };
    });
  };

  const promptsCounter = Object.keys(selectedPrompts).length;
  return (
    <Grid className={"campaignComponentContainer coachBaseContainer"}>
      <Grid.Row className={"noPaddingBottom"}>
        <Grid.Column width={3}>
          <Header as="h4"> {formatMessage({ ...descriptors[CampaignPromptsType.title] })}</Header>
        </Grid.Column>
        <Grid.Column width={13}>
          {promptsCounter > 0 && (
            <BlueTag>
              {formatMessage(
                {
                  ...descriptors[
                    CampaignPromptsType[promptsCounter > 1 ? "multipleSelectedPrompts" : "selectedPrompt"]
                  ],
                },
                { promptsCounter }
              )}
            </BlueTag>
          )}
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column>
          <SearchComponent
            cacheKey={"coachPromptsForAddCampaign"}
            refreshData={setSearchedPromptList}
            hideWhenNotSearch={true}
            filterPlaceholder={"Group by categories"}
            content={
              <PromptSearchList
                categories={categories}
                coachId={coachId}
                promptList={searchedPromptList}
                campaignPrompts={selectedPrompts}
                onAddPromptHandler={addPromptHandler}
                onRemovePromptHandler={removePromptHandler}
              />
            }
            searchFunction={PromptServices.library}
            showSortBy={false}
            filters={categoryOptions}
            pageable={false}
            onSearchedHandler={setSearchActive}
          />
          {categories && !searchActive && (
            <PromptList
              categories={categories}
              coachId={coachId}
              campaignPrompts={selectedPrompts}
              onAddPromptHandler={addPromptHandler}
              onRemovePromptHandler={removePromptHandler}
            />
          )}
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
};

export const PromptsStep = CampaignPromptFC;
